import { cn } from "../lib/utils";

type Variant = "primary" | "success" | "info";

type TagProps = {
  children: React.ReactNode;
  variant?: Variant;
  className?: string;
};

const variantClasses: Record<Variant, string> = {
  primary: "bg-primary-100 text-primary-800",
  success: "bg-green-100 text-green-800",
  info: "bg-gray-100 text-gray-800",
};

export function Tag({
  children,
  variant = "primary",
  className = "",
}: TagProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium",
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
}
